<template>
  <div class="article-container">
    <Sticky @scroll="handleScroll" :offset-top="top">
      <div class="tab-header">
        <div
          class="tab-item"
          v-for="(item, index) in tabList"
          :key="index"
          :class="{ active: active === index }"
          @click="setActiveTab(index)"
        >
          {{ item }}
          <div class="line" :class="{ active: active === index }"></div>
        </div>
      </div>
    </Sticky>
    <div v-if="page === 1">
      <div v-if="listLoading">
        <div v-if="articleData.length > 0">
          <ArticleCard
            :articleData="articleData"
            :pageType="0"
            :active="active"
            :page="page"
            v-if="articleData && articleData.length > 0"
            @showPreview="showPreview"
          />
        </div>
        <Error
          :status="{ info: msg, imgSrc: errorImg }"
          :selfStyle="{ height: 'auto', width: '100%', marginTop: '20px' }"
          v-else
        />
      </div>
      <div class="loading" v-else>
        <van-loading size="24px" vertical>{{ $t('loading') }}</van-loading>
      </div>
    </div>
    <div v-else>
      <div v-if="articleData.length > 0">
        <div v-if="type === 1">
          <ArticleCard
            :articleData="articleData"
            :key="0"
            :active="active"
            :page="page"
            v-if="articleData && articleData.length > 0"
            @showPreview="showPreview"
          />
        </div>
        <ShortVideo v-else :articleData="articleData" :active="active" />
      </div>
      <Error
        :status="{ info: msg, imgSrc: errorImg }"
        :selfStyle="{ height: 'auto', width: '100%', marginTop: '20px' }"
        v-else
      />
    </div>
  </div>
  <!-- <div v-if="type === 1">
      <div v-if="listLoading">
        <div v-if="articleData.length > 0">
          <ArticleCard
            :articleData="articleData"
            :key="0"
            :active="active"
            v-if="articleData && articleData.length > 0"
            @showPreview="showPreview"
          />
        </div>
        <Error
          :status="{ info: $t('app_empty') }"
          :selfStyle="{ height: 'auto', width: '100%', marginTop: '20px 0' }"
          v-else
        />
      </div>
      <div class="loading" v-else>
        <van-loading size="24px" vertical>加载中...</van-loading>
      </div>
    </div>
    <ShortVideo v-else :articleData="articleData" :active="active" /> -->
  <!-- </div> -->
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { useThemeColor } from '@/utils/theme'
import ArticleCard from './ArticleCard.vue'
import ShortVideo from '@/views/shortVideo/components/ShortVideo.vue'
import { Record } from '@/api/Models/CommunityBoardContentList'
import Error from '@/components/Error.vue'
import { Attachment } from '@/api/Models/Attachment'
import { useI18n } from 'vue-i18n'
import { Sticky } from 'vant'
const themeColor = useThemeColor()
const { t } = useI18n()

const props = defineProps<{
  articleData: Record[]
  top: number
  type: number // 2 短视频
  listLoading?: boolean
  page?: number
  activeType?: number
  errorMsg?: string
}>()
const tabList = computed(() => {
  return props.type === 1
    ? [t('app_all'), t('pc_community_note'), t('pc_community_article'), t('pc_community_album')]
    : [t('newest'), t('hotest')]
})
const active = ref(props.activeType || 0)
const msg = ref(props.errorMsg || t('app_empty'))
const errorImg = ref('')
watch(
  () => props.activeType,
  (newValue) => {
    active.value = newValue || 0
  }
)
watch(
  () => props.errorMsg,
  (newValue) => {
    msg.value = newValue || t('app_empty')
    errorImg.value = newValue ? 'no_permession_part_detail.png' : ''
  },
  { immediate: true }
)
const emits = defineEmits(['showPreview', 'handleScroll', 'handleActive'])
const showPreview = (data: { attachments: Attachment[]; index: number }) => {
  emits('showPreview', data)
}

const handleScroll = (info: { isFixed: boolean }) => {
  emits('handleScroll', info.isFixed)
}

const setActiveTab = (index: number) => {
  active.value = index
  emits('handleActive', index)
}
</script>

<style lang="less" scoped>
.article-container {
  :deep(.van-sticky) {
    background: #f4f5f7;
  }

  .tab-header {
    display: flex;
    align-items: center;
    flex-direction: row;
    font-weight: normal;
    height: 52px;
    position: relative;
    left: -12px;
    .tab-item {
      display: flex;
      align-items: center;
      position: relative;
      padding: 14px;
      font-size: 14px;
      color: #999;
      height: 100%;
    }

    .tab-item.active {
      font-size: 16px;
      color: #171921;
      font-weight: bold;
    }
    .line.active {
      position: absolute;
      bottom: 10px;
      width: 13px;
      height: 3px;
      background: v-bind(themeColor);
      border-radius: 1.5px;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
  .loading {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
